import React, { useEffect, useState, useMemo } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { DealBtn, Comment } from "@/module";
import { findItem, resultProcess } from "@/dic";
import { Modal } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import { arr2Dic } from "@/utils";
import "./style.less";

const NAME = "resultInfo";

const App = () => {
  const [[i18n], [IS_EN]] = useWatchState(["i18n", "IS_EN"]);
  const [[PLATFORM]] = useWatchState(["PLATFORM"]);
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[SCOPE_DIRECTION = []]] = useWatchState(["$_SCOPE_DIRECTION"]);
  const SCOPE_DIRECTION_DIC = useMemo(() => {
    return arr2Dic(SCOPE_DIRECTION, "value");
  }, [SCOPE_DIRECTION]);
  const [[{ title = "成果详情", show, hide, width = 1200, resultId = "" }]] =
    useWatchState(["modal." + NAME]);

  const [data, setData] = useState({});
  const scopes = data.scopes || [];

  useEffect(() => {
    if (resultId) {
      BaseService.list({
        table: "thtt_chengguo",
        columns: "chengguo_id,name,cover,add_time,process,profile,scope",
        where: {
          chengguo_id: resultId,
          "thtt_chengguo.is_delete": 0,
        },
        leftJoin: {
          table: "thtt_organization",
          on: "thtt_chengguo.unit = thtt_organization.organization_id",
          columns: ["name AS unitName", "profile AS unitProfile"],
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [resultId]);

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
      className="modal-resultInfo"
    >
      <h2>{data.name}</h2>
      <p className="dark-disable">{second2Date(data.add_time)}</p>
      <div className="modal-resultInfo-head p-md border flex child-left-md m-md-t">
        {data.cover && (
          <div className="modal-resultInfo-head__cover flex-shrink-0">
            <img
              className="h-full object-contain"
              src={createFilePath(data.cover, UPLOAD_SERVER_HOST)}
              alt={data.name}
            />
          </div>
        )}
        <div className="full child-top-sm">
          {/*成果阶段字段，由于成果数据没有成果阶段内容，所以隐藏该字段。
          <p>
            <span className="bold">{i18n.push.deal.resultModal.process}</span>：
            {findItem(resultProcess, data.process).label}
        </p>
        */}
          <p>
            <span className="bold">{i18n.push.deal.resultModal.org}</span>：
            {data.unitName}
          </p>
        </div>
        <div className="full child-top-sm">
          <p>
            <span className="bold">{i18n.push.deal.resultModal.scope}</span>：
            {data.scope &&
              data.scope
                .split(",")
                .map(
                  (value) =>
                    SCOPE_DIRECTION_DIC[value] &&
                    SCOPE_DIRECTION_DIC[value][IS_EN ? "name_en" : "label"]
                )
                .join("、")}
          </p>
        </div>
      </div>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.resultModal.profile}
        </h2>
        <div
          className="m-sm-t"
          dangerouslySetInnerHTML={{ __html: data.profile }}
        ></div>
      </article>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.resultModal.unitProfile}
        </h2>
        <div
          className="m-sm-t"
          dangerouslySetInnerHTML={{ __html: data.unitProfile }}
        ></div>
      </article>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.resultModal.contact}
        </h2>
        <div className="m-sm-t">Ms. Wang 15910931797</div>
      </article>

      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.resultModal.comment}
        </h2>
        <Comment className="m-sm-t" itemId={resultId} type={1} />
      </article>

      {PLATFORM === "THTT" && (
        <DealBtn
          className="modal-info-del bor-ra-xs"
          feebackProps={{ itemId: resultId, itemType: 0 }}
        />
      )}
    </Modal>
  );
};

export default App;
